import { render, staticRenderFns } from "./AmnioticTissueGraft.vue?vue&type=template&id=6db78c97&"
import script from "./AmnioticTissueGraft.vue?vue&type=script&lang=js&"
export * from "./AmnioticTissueGraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports